import { client as openApiClient } from '@/src/api/client.gen';

// Configure OpenAPI client base URL without duplicating /api/v1
const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '';
const cleanedBaseUrl = rawApiBaseUrl.replace(/\/api\/v1\/?$/, '');
if (cleanedBaseUrl) {
  openApiClient.setConfig({
    baseUrl: cleanedBaseUrl,
  });
}

/**
 * Attaches Clerk authentication JWT tokens to all outgoing OpenAPI client requests.
 */
// The client is a module singleton and its interceptor list is append-only, so
// registering again on every AuthProvider mount stacks duplicates: each one
// awaits getToken() before the request goes out. Keep the latest token getter and
// register the interceptor exactly once.
let currentGetToken: (() => Promise<string | null>) | null = null;
let interceptorRegistered = false;

export const setupAuthInterceptor = (getToken: () => Promise<string | null>) => {
  currentGetToken = getToken;
  if (interceptorRegistered) return;
  interceptorRegistered = true;
  openApiClient.interceptors.request.use(async (request) => {
    try {
      const token = currentGetToken ? await currentGetToken() : null;
      if (token) {
        if (request.headers instanceof Headers) {
          request.headers.set('Authorization', `Bearer ${token}`);
        } else if (request.headers && typeof (request.headers as any).set === 'function') {
          (request.headers as any).set('Authorization', `Bearer ${token}`);
        } else if (request.headers) {
          (request.headers as any)['Authorization'] = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error('Error fetching auth token for OpenAPI client:', error);
    }
    return request;
  });
};

export const setupApiClient = setupAuthInterceptor;
